export default {
  path: 'drug-category',
  component: () => import('@/views/settingSystem/setting-router.vue'),
  children: [
    {
      path: '',
      name: 'DrugCategoryList',
      component: () => import('@/views/settingSystem/pages/drug-category/DrugCategoryList.vue'),
      meta: {
        name: 'ตั้งค่าระบบ',
        icon: '/icons/setting.svg'
      }
    },
    {
      path: 'create',
      name: 'DrugCategoryCreate',
      component: () => import('@/views/settingSystem/pages/drug-category/DrugCategoryCreate.vue'),
      meta: {
        name: 'ตั้งค่าระบบ',
        icon: '/icons/setting.svg'
      }
    },
    {
      path: 'edit/:id',
      name: 'DrugCategoryEdit',
      component: () => import('@/views/settingSystem/pages/drug-category/DrugCategoryEdit.vue'),
      meta: {
        name: 'ตั้งค่าระบบ',
        icon: '/icons/setting.svg'
      }
    }
  ]
}
